// 轻松使用localStorage
import {settings} from '../settings'
import Lockr from 'lockr'

// 设置key值前缀
Lockr.prefix = settings.lockr_prefix

// Lockr.prefix 设置key值前缀
// Lockr.set(key, value) value 支持string number Object
// Lockr.get(key) 获取值，如果key===null/undefined 返回默认值
// Lockr.rm(key) 删除键值对
// Lockr.sadd(key, value) 追加一个值,value支持string number Object，返回数组
// Lockr.sismember(key, value) // 判断指定键是否存在那个值
// Lockr.srem(key, value) // 移除指定健中的指定value
// Lockr.getAll() // 获得所有键值对
// Lockr.flush() // 清空所有键值对

class PcLockr {
    constructor() {
        this.pcPrefix = settings.lockr_prefix
    }

    // 设置本地存储
    set(key, value, fn) {
        PcLockr.checkKey(key)
        Lockr.set(key, value)
        fn && fn()
    }

    // 获得本地存储
    get(key) {
        PcLockr.checkKey(key)
        return Lockr.get(key)
    }

    // 删除本地存储
    delete(key, fn) {
        PcLockr.checkKey(key)
        Lockr.rm(key)
        fn && fn()
    }

    // 指定key追加指定value
    add(key, value, fn) {
        PcLockr.checkKey(key)
        Lockr.sadd(key, value)
        fn && fn()
    }

    getList(key) {
        PcLockr.checkKey(key)
        return Lockr.smembers(key)
    }

    // 获得所有存储值
    getAll() {
        return Lockr.getAll()
    }
    // 指定key是否包含指定value 返回值Boolean
    contains(key, value, fn) {
        PcLockr.checkKey(key)
        return Lockr.sismember(key, value)
    }

    // 移除指定key下的指定value
    remove(key, value, fn) {
        PcLockr.checkKey(key)
        Lockr.srem(key, value)
        fn && fn()
    }

    // 移除所有key的value值
    removeAll(key, fn) {
        PcLockr.checkKey(key)
        let smembers = Lockr.smembers(key)
        for (let index in smembers) {
            Lockr.srem(key, smembers[index])
        }
        fn && fn()
    }

    // 清空所有存储
    clear(fn) {
        Lockr.flush()
        fn && fn()
    }

    static checkKey(key) {
        if (!key) {
            throw new Error('没有找到key。')
        }
        if (typeof key === 'object') {
            throw new Error('key不能是一个对象。')
        }
    }
}

export default new PcLockr()



// WEBPACK FOOTER //
// ./src/util/lockr/index.js